import { useState, useEffect } from "react";
import styles from "./GalleryComponent.module.scss";
import Image from "next/image";

const GalleryComponent = ({ GalleryData }) => {
    const [activeLink, setActiveLink] = useState('All');
    const [filteredData, setFilteredData] = useState(GalleryData);
    const [visibleItems, setVisibleItems] = useState(9); // State to track number of visible items
    const [loading, setLoading] = useState(true); // State to track loading
    const tabs = ["All", "View", "Activities", "Accommodation", "Dining", "Videos", "Wedding & Events"];
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const handleTabChange = (tab) => {
        let filteredItem;
        setLoading(true); // Show skeleton loader when switching tabs
        if (tab === 'All') {
            filteredItem = GalleryData;
        } else {
            filteredItem = GalleryData.filter(item => item.category === tab);
        }
        setFilteredData(filteredItem);
        setActiveLink(tab);
        setVisibleItems(9); // Reset visible items when switching tabs
        setTimeout(() => {
            setLoading(false); // Hide skeleton loader after loading
        }, 1000); // Simulate loading time
    };

    const loadMoreItems = () => {
        setLoading(true); // Show skeleton loader when loading more items
        setTimeout(() => {
            setVisibleItems(prevVisibleItems => prevVisibleItems + 9);
            setLoading(false); // Hide skeleton loader after loading more items
        }, 1000); // Simulate loading time
    };

    useEffect(() => {
        // Set initial data to show all items
        setFilteredData(GalleryData);
        setLoading(false); // Hide skeleton loader after initial load
    }, [GalleryData]);

    const displayedData = filteredData.slice(0, visibleItems);
    const showLoadMore = filteredData.length > visibleItems;

    //...................Gallery Modal......................
    const openModal = (imageData) => {
        setSelectedImage(imageData);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedImage(null); // Reset selected image when closing modal
    };

    const goToPrevious = (e) => {
        e.stopPropagation();
        const currentIndex = filteredData.indexOf(selectedImage);
        const prevIndex = currentIndex === 0 ? filteredData.length - 1 : currentIndex - 1;
        setSelectedImage(filteredData[prevIndex]);
    };

    const goToNext = (e) => {
        e.stopPropagation();
        const currentIndex = filteredData.indexOf(selectedImage);
        const nextIndex = currentIndex === filteredData.length - 1 ? 0 : currentIndex + 1;
        setSelectedImage(filteredData[nextIndex]);
    };

    return (
        <>
            <div className={styles.gallery_tab_bar}>
                {tabs.map((tab, index) => (
                    <button className={activeLink === tab ? `${styles.active_tab}` : ''}
                        onClick={() => handleTabChange(tab)}
                        key={index}
                    >
                        {tab}
                    </button>
                ))}
            </div>
            <div className={styles.gallery_card_parent}>
                {displayedData.map((filteredProperty, index) => (
                    <div
                        className={styles.gallery_card_img_parent}
                        key={index}
                        onClick={() => openModal(filteredProperty)}
                    >
                        <div className={styles.gallery_card_img}>
                            {filteredProperty?.videoUrl ? (
                                <div className={styles.video_wrapper}>
                                    <div
                                        className={styles.overlay}
                                        onClick={() => openModal(filteredProperty)}
                                    ></div>
                                    <iframe
                                        width="100%"
                                        height="100%"
                                        src={`https://www.youtube.com/embed/${filteredProperty?.videoUrl}?autoplay=1&loop=1&playlist=${filteredProperty?.videoUrl}&mute=1&modestbranding=1&controls=0&rel=0`}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    ></iframe>
                                </div>
                            ) : (
                                <div
                                    style={{ height: '100%', position: 'relative' }}
                                >
                                    {loading ? (
                                        <div className={styles.skeleton} />
                                    ) : (
                                        <Image
                                            src={filteredProperty?.image}
                                            alt=""
                                            fill={true}
                                            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                            onLoadingComplete={() => setLoading(false)}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                ))}

                {modalOpen && (
                    <div className={styles.modal_overlay} onClick={closeModal}>
                        <button className={styles.close_button} onClick={closeModal}>
                            &times;
                        </button>
                        {selectedImage ? (
                            <>
                                {selectedImage.videoUrl ? (
                                    <iframe
                                        width="100%"
                                        height="100%"
                                        src={`https://www.youtube.com/embed/${selectedImage.videoUrl}?autoplay=1&loop=1&playlist=${selectedImage.videoUrl}&mute=1&modestbranding=1&controls=0&rel=0`}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    ></iframe>
                                ) : (
                                    <img
                                        src={selectedImage.image}
                                        className={styles.modal_image}
                                        alt=""
                                    />
                                )}
                                <button className={styles.prev_button} onClick={goToPrevious}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z" /></svg>
                                </button>
                                <button className={styles.next_button} onClick={goToNext}>
                                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff"><path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" /></svg>
                                </button>
                            </>
                        ) : (
                            <div className={styles.loader}></div>
                        )}
                    </div>
                )}
            </div>
            {showLoadMore && (
                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <button className="common_btn" onClick={loadMoreItems}>Load More</button>
                </div>
            )}
        </>
    );
}

export default GalleryComponent;
